import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSawRivalsPlayPageHighlight } from '@sorare/core/src/hooks/rivals/useSawRivalsPlayPageHighlight';
import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';

export const usePlayPageOnboarding = () => {
  const sawRivalsPlayPageHighlight = useSawRivalsPlayPageHighlight();
  const { onboarded } = useCurrentUserContext();
  const {
    flags: { useRivalsPlayPageOnboarding = false },
  } = useFeatureFlags();
  let onboardingMode: 'rivals' | undefined;

  if (
    !sawRivalsPlayPageHighlight &&
    !onboarded.FOOTBALL &&
    useRivalsPlayPageOnboarding
  ) {
    onboardingMode = 'rivals';
  }

  return onboardingMode;
};
